/*LIBRARY*/
import { useState, useCallback, useEffect } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";
import SS_SAVE_FORMULA from "./SS_SAVE_FORMULA";

/*REDUX*/
import {
  set_value_insight,
  push_value_insight,
} from "../../App/actions/insight_v2";
import { show_top_result } from "../../App/actions/site_selections";

/*PICTURE*/
import ICON_ARROW_DOWN from "../../Assets/jsx/ICON_ARROW_DOWN";
import ICON_ARROW_UP from "../../Assets/jsx/ICON_ARROW_UP";
import ICON_EXPAND_BOTTOM from "../../Assets/jsx/ICON_EXPAND_BOTTOM";
import ICON_COLLAPSE_TOP from "../../Assets/jsx/ICON_COLLAPSE_TOP";
import ICON_CLOSE_X from "../../Assets/jsx/ICON_CLOSE_X";

/*FUNCTION*/
import run_scoring from "../../Functions/insight/run_scoring";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const SS_FORMULA = ({
  insight_reducer,
  set_value_insight,
  loading_reducer,
  push_value_insight,
  show_top_result,
  auth,
}) => {
  //local storage
  const language = localStorage?.language || auth.language;

  //local state
  const [state, setState] = useState({
    mode_input: "single_input", //hirarki || single_input
    modal_payment: false,
    modal_choose_poi: false,
    modal_demography: false,
    modal_save_formula: false,
  });
  const [is_show_info, set_is_show_info] = useState(false);
  const [modal_edit_weight, set_modal_edit_weight] = useState(false);
  const [anchor, set_anchor] = useState(null);
  const [weight_score_selected, set_weight_score_selected] = useState(1);
  const [key_selected, set_key_selected] = useState("");
  const { modal_save_formula } = state;

  //global props
  const { array_formula_insight, array_group_insight, tipe_level } =
    insight_reducer;
  const { loading_item_array } = loading_reducer;

  // Auto-scroll effect when formula loading state changes
  useEffect(() => {
    if (loading_item_array.includes("template_formula")) {
      const element = document.getElementById("formula_container");
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  }, [loading_item_array]);

  const delete_formula = (item) => {
    let { array_formula_insight } = insight_reducer;
    array_formula_insight = array_formula_insight.filter(
      (element) => element.key !== item.key
    );
    set_value_insight({
      key: "array_formula_insight",
      value: array_formula_insight,
    });
    if (item.group === "poi") {
      if (tipe_level === "tipe_1") {
        on_toggle_tipe_1(item);
      } else if (tipe_level === "tipe_2") {
        on_toggle_tipe_2(item);
      } else if (tipe_level === "tipe_3") {
        on_toggle_tipe_3(item);
      }
    }
  };

  const on_toggle_tipe_1 = (item_1) => {
    const { list_tipe_2, list_tipe_3 } = insight_reducer;

    set_value_insight({ key: "tipe_1_all", value: false });
    const { tipe_1_array, tipe_2_array, tipe_3_array } = insight_reducer;
    const is_active = tipe_1_array.some(
      (element) => element.TIPE_1 === item_1.TIPE_1
    );
    if (!is_active) {
      push_value_insight({ key: "tipe_1_array", value: item_1 });
      const tipe_2_array_new = [
        ...tipe_2_array,
        ...list_tipe_2.filter((item_2) => item_2.TIPE_1 === item_1.TIPE_1),
      ];
      set_value_insight({
        key: "tipe_2_array",
        value: tipe_2_array_new,
      });
      const tipe_3_array_new = [
        ...tipe_3_array,
        ...list_tipe_3.filter((item_3) => item_3.TIPE_1 === item_1.TIPE_1),
      ];
      set_value_insight({
        key: "tipe_3_array",
        value: tipe_3_array_new,
      });
    } else {
      set_value_insight({
        key: "tipe_1_array",
        value: tipe_1_array.filter(
          (element) => element.TIPE_1 !== item_1.TIPE_1
        ),
      });
      set_value_insight({
        key: "tipe_2_array",
        value: tipe_2_array.filter((item_2) => item_2.TIPE_1 !== item_1.TIPE_1),
      });
      set_value_insight({
        key: "tipe_3_array",
        value: tipe_3_array.filter((item_3) => item_3.TIPE_1 !== item_1.TIPE_1),
      });
    }
  };

  const on_toggle_tipe_2 = (item_2) => {
    const { list_tipe_3 } = insight_reducer;
    const { tipe_3_array, tipe_2_array, tipe_1_array } = insight_reducer;
    set_value_insight({ key: "tipe_1_all", value: false });
    const is_active = tipe_2_array.some(
      (element) =>
        element.TIPE_1 === item_2.TIPE_1 && element.TIPE_2 === item_2.TIPE_2
    );
    if (!is_active) {
      //push tipe 2
      push_value_insight({ key: "tipe_2_array", value: item_2 });
      //push tipe 3
      const tipe_3_array_new = [
        ...tipe_3_array,
        ...list_tipe_3.filter(
          (item_3) =>
            item_3.TIPE_1 === item_2.TIPE_1 && item_3.TIPE_2 === item_2.TIPE_2
        ),
      ];
      set_value_insight({
        key: "tipe_3_array",
        value: tipe_3_array_new,
      });
    } else {
      //pull tipe 2
      set_value_insight({
        key: "tipe_2_array",
        value: tipe_2_array.filter(
          (element) =>
            !(
              element.TIPE_1 === item_2.TIPE_1 &&
              element.TIPE_2 === item_2.TIPE_2
            )
        ),
      });
      //pull tipe 3
      set_value_insight({
        key: "tipe_3_array",
        value: tipe_3_array.filter(
          (item_3) =>
            item_3.TIPE_1 !== item_2.TIPE_1 && item_3.TIPE_2 !== item_2.TIPE_2
        ),
      });
    }
    const TIPE_1 = item_2.TIPE_1;
    set_value_insight({
      key: "tipe_1_array",
      value: tipe_1_array.filter((element) => element.TIPE_1 !== TIPE_1),
    });
  };

  const on_toggle_tipe_3 = (item_3) => {
    const { tipe_3_array, tipe_1_array } = insight_reducer;
    set_value_insight({ key: "tipe_1_all", value: false });
    const is_active = tipe_3_array.some(
      (element) =>
        element.TIPE_1 === item_3.TIPE_1 &&
        element.TIPE_2 === item_3.TIPE_2 &&
        element.TIPE_3 === item_3.TIPE_3
    );
    if (!is_active) {
      push_value_insight({ key: "tipe_3_array", value: item_3 });
    } else {
      set_value_insight({
        key: "tipe_3_array",
        value: tipe_3_array.filter(
          (element) =>
            !(
              element.TIPE_1 === item_3.TIPE_1 &&
              element.TIPE_2 === item_3.TIPE_2 &&
              element.TIPE_3 === item_3.TIPE_3
            )
        ),
      });
    }
    const TIPE_1 = item_3.TIPE_1;
    set_value_insight({
      key: "tipe_1_array",
      value: tipe_1_array.filter((element) => element.TIPE_1 !== TIPE_1),
    });
  };

  const toggle_show_info = useCallback(() => {
    set_is_show_info((prev) => !prev);
  }, []);

  const on_run_scoring = () => {
    set_value_insight({
      key: "is_allow_save",
      value: true,
    });
    let {
      features_grid,
      array_formula_insight,
      array_group_insight,
      config_final_score,
    } = insight_reducer;
    run_scoring({
      features_grid,
      array_formula_insight,
      array_group_insight,
      config_final_score,
      set_value_insight: set_value_insight,
      show_top_result,
    });
  };

  const on_change_weight = (event) => {
    const name = event.target.name;
    const value = Number(event.target.value);
    set_weight_score_selected(value);
    if (value >= 0) {
      const { array_formula_insight } = insight_reducer;
      const object = array_formula_insight.find((item) => item.key === name);
      object.weight_score = value;
      set_value_insight({
        key: "array_formula_insight",
        value: array_formula_insight,
      });
      on_run_scoring();
    }
  };

  const toggle_is_directly_proportional = (key) => {
    const { array_formula_insight } = insight_reducer;
    const object = array_formula_insight.find((item) => item.key === key);
    object.is_directly_proportional = !object.is_directly_proportional;
    set_value_insight({
      key: "array_formula_insight",
      value: array_formula_insight,
    });
    on_run_scoring();
  };

  const toggle_edit_weight = (event) => {
    if (event) {
      set_modal_edit_weight(true);
      set_anchor(event?.currentTarget);
      const key_selected = event.target.id;
      const { array_formula_insight } = insight_reducer;
      const object = array_formula_insight.find(
        (item) => item.key === key_selected
      );
      const weight_score_selected = object.weight_score;
      set_key_selected(key_selected);
      set_weight_score_selected(weight_score_selected);
    } else {
      set_modal_edit_weight(false);
      set_anchor("");
    }
  };

  const toggle_save_formula = () => {
    setState((prevState) => ({
      ...prevState,
      modal_save_formula: !prevState.modal_save_formula,
    }));
  };

  const modal_edit_weight_content = (
    <FLOAT_MENU
      id="basic-menu"
      anchorEl={anchor}
      open={modal_edit_weight}
      onClose={toggle_edit_weight}
    >
      <div style={{ width: "100px" }}>
        <input
          type="number"
          name={key_selected}
          value={weight_score_selected}
          onChange={on_change_weight}
        />
      </div>
    </FLOAT_MENU>
  );

  const modal_save_formula_content = modal_save_formula && (
    <Modal
      modalSize="small"
      id="modal_save_formula"
      isOpen={modal_save_formula}
      onClose={toggle_save_formula}
    >
      <div className="box-body">
        <SS_SAVE_FORMULA toggle_save_formula={toggle_save_formula} />
      </div>
    </Modal>
  );

  return (
    <main>
      {modal_edit_weight_content}
      {modal_save_formula_content}
      <section
        className={`container background_grey_light margin_bottom margin_top ${
          loading_item_array.includes("template_formula") &&
          "glowing_outline_radius"
        }`}
        id="formula_container"
      >
        <section>
          {array_group_insight.map((parent) => {
            const child_array = array_formula_insight.filter(
              (child) => child.group === parent.key
            );
            return (
              <article key={parent.key}>
                <span className="badge_small background_black margin_bottom">
                  {parent.key}
                </span>
                <div>
                  {child_array.map((child) => {
                    const { is_directly_proportional, weight_score } = child;
                    let name = child.key;
                    let title = child.key;
                    if (parent.key === "poi") {
                      if (tipe_level === "tipe_1") {
                        name = child?.TIPE_1;
                        title = `TIPE 1: ${child?.TIPE_1}`;
                      } else if (tipe_level === "tipe_2") {
                        name = child?.TIPE_2;
                        title = `TIPE 1: ${child?.TIPE_1}
TIPE 2: ${child?.TIPE_2}`;
                      } else if (tipe_level === "tipe_3") {
                        name = child?.TIPE_3;
                        title = `Tipe 1: ${child?.TIPE_1}
Tipe 2: ${child?.TIPE_2}
Tipe 3: ${child?.TIPE_3}`;
                      }
                    }
                    return (
                      <article key={child.key}>
                        <span className="badge background_white outline_grey margin_bottom">
                          <section
                            style={{
                              display: "grid",
                              gridTemplateColumns: "20px 30px auto 30px",
                              gridGap: "10px",
                              alignItems: "center",
                            }}
                            title={title}
                          >
                            <button
                              className={`badge_circle ${
                                is_directly_proportional
                                  ? "background_green"
                                  : "background_red"
                              }`}
                              onClick={() =>
                                toggle_is_directly_proportional(child.key)
                              }
                            >
                              {is_directly_proportional ? (
                                <ICON_ARROW_UP line_color="#fff" />
                              ) : (
                                <ICON_ARROW_DOWN line_color="#fff" />
                              )}
                            </button>
                            <button
                              className="button_small button_white outline_grey"
                              id={child.key}
                              onClick={toggle_edit_weight}
                            >
                              {weight_score}
                            </button>
                            <p className="text_small text_left">{name}</p>
                            <ICON_CLOSE_X
                              onClick={() => delete_formula(child)}
                              color="#000"
                              style={{
                                width: "16px",
                                marginLeft: "10px",
                                cursor: "pointer",
                              }}
                            />
                          </section>
                        </span>
                      </article>
                    );
                  })}
                </div>
                <hr />
              </article>
            );
          })}
        </section>
        <button
          className="button button_white outline_black"
          onClick={toggle_save_formula}
          data-mapid="clickSaveTemplateFormula"
        >
          {dict?.["Save Formula As Template"]?.[language]}
        </button>
      </section>

      <div
        onClick={toggle_show_info}
        className="button_with_icon button_white outline_black margin_bottom"
      >
        {dict?.["Information"]?.[language]}

        {is_show_info ? (
          <ICON_COLLAPSE_TOP
            color="#000"
            style={{ width: "17px", marginLeft: "10px" }}
          />
        ) : (
          <ICON_EXPAND_BOTTOM
            color="#000"
            style={{ width: "17px", marginLeft: "10px" }}
          />
        )}
      </div>

      {is_show_info && (
        <section>
          <div className="container background_grey_light">
            <h1 className="text_bold margin_bottom_extra">
              {dict?.["Site Selection Formula Parameter Guide"]?.[language]}
            </h1>

            <div className="margin_bottom">
              <span className="text_bold">
                {dict?.["Positive Correlation/"]?.[language]}
                <br />
                {dict?.["Directly proportional"]?.[language]}(
              </span>
              <div className="badge_circle background_green">
                <ICON_ARROW_UP line_color="#fff" />
              </div>
              <span className="text_bold">)</span>
            </div>

            <p className="text_medium sub_color margin_bottom">
              {dict?.["Definition:"]?.[language]}
              <br />
              {
                dict?.[
                  "Parameters with positive correlation will increase the final score as the value of the parameter increases."
                ]?.[language]
              }
              <br />
              {
                dict?.[
                  "Use this setting when you are looking for regions with high concentrations of the desired parameter."
                ]?.[language]
              }
            </p>

            <p className="text_medium sub_color margin_bottom">
              {dict?.["Implementation example:"]?.[language]}
              <br />
              {
                dict?.[
                  "- Opening a cafe or restaurant: look for areas with the highest office or university density"
                ]?.[language]
              }
              <br />
              {
                dict?.[
                  "- Opening a grocery store: identifying areas with the largest concentration of households and productive age population"
                ]?.[language]
              }
            </p>

            <br />
            <br />

            <div className="margin_bottom">
              <span className="text_bold">
                {dict?.["Negative Correlation/"]?.[language]}
                <br />
                {dict?.["Inversely proportional"]?.[language]}(
              </span>
              <div className="badge_circle background_red">
                <ICON_ARROW_DOWN line_color="#fff" />
              </div>
              <span className="text_bold">)</span>
            </div>

            <p className="text_medium sub_color margin_bottom">
              {dict?.["Definition:"]?.[language]}
              <br />
              {
                dict?.[
                  "Parameters with negative correlation will increase the final score when the value of the parameter is low."
                ]?.[language]
              }
              <br />
              {
                dict?.[
                  "Use this setting to avoid areas with high concentrations of unwanted factors."
                ]?.[language]
              }
            </p>

            <p className="text_medium sub_color margin_bottom">
              {dict?.["Implementation example:"]?.[language]}
              <br />
              {
                dict?.[
                  "- Opening a premium store or boutique: avoiding areas with high poverty rates by choosing unemployment demographics as a negative correlation"
                ]?.[language]
              }
              <br />
              {
                dict?.[
                  "- Opening a family-friendly business: identifying areas with minimal air pollution levels by selecting toll gates as a negative correlation"
                ]?.[language]
              }
            </p>

            <br />
            <br />

            <p className="text_bold margin_bottom">
              {dict?.["Parameter Weight"]?.[language]}

              <button className="button button_white outline_grey">1</button>
            </p>

            <p className="text_medium sub_color margin_bottom">
              {dict?.["Definition:"]?.[language]}
              <br />
              {
                dict?.[
                  "Parameter weights determine the relative level of influence a parameter has on the final score calculation."
                ]?.[language]
              }
              <br />
              {
                dict?.[
                  "Parameters with higher weights will have a more significant impact in determining the analysis results."
                ]?.[language]
              }
            </p>

            <p className="text_medium sub_color margin_bottom">
              {dict?.["Implementation example:"]?.[language]}
              <br />
              {
                dict?.[
                  "- Opening a pharmacy: weight of elderly population density = 3, weight of transportation access = 1"
                ]?.[language]
              }
              <br />
              {
                dict?.[
                  "- Opening a gym: weight of productive age population = 2, weight of income level = 2, weight of competitor density = 1"
                ]?.[language]
              }
            </p>

            <p className="text_medium sub_color margin_bottom">
              {dict?.["Results:"]?.[language]}
              <br />
              {
                dict?.[
                  "The parameter with the highest weight will have the most dominant influence in the site selection process."
                ]?.[language]
              }
            </p>

            <div className="text_center">
              <div
                onClick={toggle_show_info}
                className="button_with_icon button_white outline_black margin_bottom"
              >
                {dict?.["Close"]?.[language]}
                <ICON_COLLAPSE_TOP
                  color="#000"
                  style={{ width: "17px", marginLeft: "10px" }}
                />
              </div>
            </div>
          </div>
        </section>
      )}
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  insight_reducer: state.insight_reducer,
  layer: state.layer,
  map: state.map,
  project: state.project,
  payment: state.payment,
  sini: state.sini,
  properties: state.properties,
  license_reducer: state.license_reducer,
  loading_reducer: state.loading_reducer,
});

export default connect(mapStateToProps, {
  set_value_insight,
  push_value_insight,
  show_top_result,
})(SS_FORMULA);
